import { colors } from '../../colors';
var address = {
  arrowColor: colors.pine,
  textColor: colors.ash,
  borderColor: colors.white,
  backgroundColor: colors.alabaster
};
export default address;